import { Flex } from 'antd'
import styles from './style.module.scss'

interface Props {
  title: string
  description: string
  image: string
}

export default function Banner({ title, description, image }: Props) {
  return (
    <Flex
      vertical
      align='center'
      justify='flex-end'
      className={styles.banner}
      style={{ backgroundImage: `url(${image})` }}
    >
      <h2>{title}</h2>
      <div className={styles.description}>{description}</div>
    </Flex>
  )
}
